<template>
  <header class="header" :class="{ 'header--pages-bg': isPagesBg }">
    <button class="header__link" @click="redirectToHome">
      <div class="header__logo">
        <template v-if="isPagesBg">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="74.525"
            height="38.401"
            viewBox="0 0 74.525 38.401"
          >
            <path
              id="logo-boost-white"
              d="M1338.849,1175.479v-2.826h-5.174v-7.63h-3.111v7.63H1327.4a5.512,5.512,0,0,0-.884-1.044,5.965,5.965,0,0,0-4.233-1.592,6.385,6.385,0,0,0-4.268,1.483,4.83,4.83,0,0,0-1.7,3.765,9.37,9.37,0,0,0-1.814-2.462,9.52,9.52,0,0,0-6.983-2.786,9.659,9.659,0,0,0-7.019,2.786,9.169,9.169,0,0,0-2.227,3.41,9.161,9.161,0,0,0-2.225-3.41,9.52,9.52,0,0,0-6.983-2.786,9.66,9.66,0,0,0-7.019,2.786,9.046,9.046,0,0,0-2.683,5.173,5.938,5.938,0,0,0-3.393-2.315,6.166,6.166,0,0,0,3.185-5.463,5.976,5.976,0,0,0-1.846-4.487,6.277,6.277,0,0,0-4.559-1.772h-8.43V1188.9h9.48a6.744,6.744,0,0,0,4.884-1.917,6.124,6.124,0,0,0,1.645-2.667,9.415,9.415,0,0,0,1.718,2.27,9.631,9.631,0,0,0,7.019,2.75,9.492,9.492,0,0,0,6.983-2.75,9.158,9.158,0,0,0,2.225-3.431,9.166,9.166,0,0,0,2.227,3.431,9.63,9.63,0,0,0,7.019,2.75,9.6,9.6,0,0,0,8.615-4.878,5.312,5.312,0,0,0,1.7,3.25,6.374,6.374,0,0,0,4.451,1.628,6.639,6.639,0,0,0,4.451-1.52,5.116,5.116,0,0,0,1.773-4.052c0-2.75-1.773-4.594-5.354-5.536-2.424-.578-3.619-1.592-3.619-3.075a2.557,2.557,0,0,1,2.715-2.315,2.69,2.69,0,0,1,2.785,2.641h5.53v8.408a5.015,5.015,0,0,0,5.015,5.015h3.27v-2.859h-5.174v-10.564Zm-71.3-8.539h4.414a3.8,3.8,0,1,1,0,7.6h-4.414Zm5.5,18.959h-5.5v-8.5h5.5a4.252,4.252,0,0,1,0,8.5m20.729-1.448a6.863,6.863,0,0,1-9.443,0,6.461,6.461,0,0,1-1.881-4.775,6.6,6.6,0,1,1,13.2,0,6.459,6.459,0,0,1-1.881,4.775m18.453,0a6.863,6.863,0,0,1-9.443,0,6.463,6.463,0,0,1-1.881-4.775,6.6,6.6,0,1,1,13.2,0,6.458,6.458,0,0,1-1.881,4.775m9.407-3.546c2.424.615,3.618,1.665,3.618,3.148a2.686,2.686,0,0,1-2.93,2.461,2.932,2.932,0,0,1-3.039-2.859h-2.747a9.873,9.873,0,0,0,.792-3.979,11.109,11.109,0,0,0-.082-1.288,7.647,7.647,0,0,0,4.389,2.517m-50.4,13.79-2.976,4.735v2.776h-.961v-2.776l-2.976-4.735h1.1l2.375,3.756,2.364-3.756Zm3.363-.131a3.636,3.636,0,0,0-2.723,1.121,3.79,3.79,0,0,0-1.087,2.766,3.831,3.831,0,0,0,1.087,2.775,3.88,3.88,0,0,0,5.435,0,3.836,3.836,0,0,0,1.1-2.775,3.8,3.8,0,0,0-1.1-2.766,3.611,3.611,0,0,0-2.712-1.121m2.005,5.978a2.834,2.834,0,0,1-4.021,0,3.125,3.125,0,0,1,0-4.181,2.83,2.83,0,0,1,4.021,0,3.094,3.094,0,0,1,0,4.181m7.553-5.846h.961v4.637a2.915,2.915,0,0,1-.854,2.144,2.816,2.816,0,0,1-2.11.861,2.849,2.849,0,0,1-2.111-.861,2.948,2.948,0,0,1-.844-2.144V1194.7h.96v4.616a2.074,2.074,0,0,0,.57,1.481,2.036,2.036,0,0,0,2.86,0,2.075,2.075,0,0,0,.57-1.481Zm6.266,3.734a2.364,2.364,0,0,0-.158-3.081,2.184,2.184,0,0,0-1.615-.653h-2.364v7.511h.971v-2.983h.792l1.847,2.983h1.171l-1.92-3.027a2.105,2.105,0,0,0,1.277-.751m-3.166-.076v-2.722h1.372a1.362,1.362,0,0,1,0,2.722Zm10.329-.131a1.866,1.866,0,0,0,.929-1.643,1.827,1.827,0,0,0-.538-1.35,1.8,1.8,0,0,0-1.33-.534h-2.459v7.511h2.765a2.05,2.05,0,0,0,.633-3.984m-2.459-2.623h1.288a1.1,1.1,0,0,1,1.107,1.143,1.126,1.126,0,0,1-.327.817,1.066,1.066,0,0,1-.78.326h-1.288Zm1.6,5.7h-1.6v-2.559h1.6a1.28,1.28,0,0,1,0,2.559m8.228-6.608h.961v4.637a2.916,2.916,0,0,1-.855,2.144,2.817,2.817,0,0,1-2.111.861,2.847,2.847,0,0,1-2.11-.861,2.947,2.947,0,0,1-.844-2.144V1194.7h.96v4.616a2.073,2.073,0,0,0,.57,1.481,2.037,2.037,0,0,0,2.86,0,2.075,2.075,0,0,0,.57-1.481Zm6.657,5.486a2,2,0,0,1-.676,1.546,2.451,2.451,0,0,1-1.688.61,2.4,2.4,0,0,1-1.689-.643,2.137,2.137,0,0,1-.675-1.612h.982a1.322,1.322,0,0,0,.4.969,1.408,1.408,0,0,0,1,.392,1.251,1.251,0,0,0,1.351-1.2c0-.676-.527-1.143-1.594-1.416-1.351-.337-2.026-1.076-2.026-2.2a1.9,1.9,0,0,1,.644-1.47,2.248,2.248,0,0,1,1.6-.6,2.222,2.222,0,0,1,1.6.622,2,2,0,0,1,.643,1.534h-.981a1.237,1.237,0,0,0-1.277-1.264,1.17,1.17,0,0,0-1.245,1.132c0,.642.5,1.1,1.488,1.361,1.425.36,2.132,1.111,2.132,2.232m.46-5.486H1315v.936h-.982v5.638H1315v.937h-2.924v-.937h.982v-5.638h-.982Zm9.124,0h.96v7.511h-.992l-4.116-5.845v5.845h-.971V1194.7h1l4.115,5.867Zm3.691,6.575h3.114v.937h-4.084V1194.7h4.031v.936h-3.061v2.329h2.712v.937h-2.712Zm8.376-1.089a2,2,0,0,1-.675,1.546,2.451,2.451,0,0,1-1.688.61,2.4,2.4,0,0,1-1.689-.643,2.135,2.135,0,0,1-.675-1.612h.981a1.32,1.32,0,0,0,.4.969,1.409,1.409,0,0,0,1,.392,1.251,1.251,0,0,0,1.351-1.2c0-.676-.528-1.143-1.594-1.416-1.35-.337-2.026-1.076-2.026-2.2a1.9,1.9,0,0,1,.644-1.47,2.249,2.249,0,0,1,1.6-.6,2.222,2.222,0,0,1,1.6.622,2,2,0,0,1,.643,1.534h-.981a1.237,1.237,0,0,0-1.277-1.264,1.17,1.17,0,0,0-1.245,1.132c0,.642.5,1.1,1.488,1.361,1.425.36,2.131,1.111,2.131,2.232m5.02,0a2,2,0,0,1-.676,1.546,2.451,2.451,0,0,1-1.688.61,2.4,2.4,0,0,1-1.689-.643,2.134,2.134,0,0,1-.676-1.612h.982a1.323,1.323,0,0,0,.4.969,1.409,1.409,0,0,0,1,.392,1.251,1.251,0,0,0,1.351-1.2c0-.676-.528-1.143-1.594-1.416-1.351-.337-2.026-1.076-2.026-2.2a1.9,1.9,0,0,1,.644-1.47,2.249,2.249,0,0,1,1.6-.6,2.222,2.222,0,0,1,1.6.622,2,2,0,0,1,.643,1.534h-.981a1.237,1.237,0,0,0-1.277-1.264,1.17,1.17,0,0,0-1.246,1.132c0,.642.5,1.1,1.489,1.361,1.424.36,2.132,1.111,2.132,2.232"
              transform="translate(-1264.323 -1163.938)"
              fill="#fff"
            />
          </svg>
        </template>
        <template v-else>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="74.525"
            height="38.401"
            viewBox="0 0 74.525 38.401"
          >
            <path
              id="Caminho_11413"
              data-name="Caminho 11413"
              d="M1338.849,1175.479v-2.826h-5.174v-7.63h-3.111v7.63H1327.4a5.512,5.512,0,0,0-.884-1.044,5.965,5.965,0,0,0-4.233-1.592,6.385,6.385,0,0,0-4.268,1.483,4.83,4.83,0,0,0-1.7,3.765,9.37,9.37,0,0,0-1.814-2.462,9.52,9.52,0,0,0-6.983-2.786,9.659,9.659,0,0,0-7.019,2.786,9.169,9.169,0,0,0-2.227,3.41,9.161,9.161,0,0,0-2.225-3.41,9.52,9.52,0,0,0-6.983-2.786,9.66,9.66,0,0,0-7.019,2.786,9.046,9.046,0,0,0-2.683,5.173,5.938,5.938,0,0,0-3.393-2.315,6.166,6.166,0,0,0,3.185-5.463,5.976,5.976,0,0,0-1.846-4.487,6.277,6.277,0,0,0-4.559-1.772h-8.43V1188.9h9.48a6.744,6.744,0,0,0,4.884-1.917,6.124,6.124,0,0,0,1.645-2.667,9.415,9.415,0,0,0,1.718,2.27,9.631,9.631,0,0,0,7.019,2.75,9.492,9.492,0,0,0,6.983-2.75,9.158,9.158,0,0,0,2.225-3.431,9.166,9.166,0,0,0,2.227,3.431,9.63,9.63,0,0,0,7.019,2.75,9.6,9.6,0,0,0,8.615-4.878,5.312,5.312,0,0,0,1.7,3.25,6.374,6.374,0,0,0,4.451,1.628,6.639,6.639,0,0,0,4.451-1.52,5.116,5.116,0,0,0,1.773-4.052c0-2.75-1.773-4.594-5.354-5.536-2.424-.578-3.619-1.592-3.619-3.075a2.557,2.557,0,0,1,2.715-2.315,2.69,2.69,0,0,1,2.785,2.641h5.53v8.408a5.015,5.015,0,0,0,5.015,5.015h3.27v-2.859h-5.174v-10.564Zm-71.3-8.539h4.414a3.8,3.8,0,1,1,0,7.6h-4.414Zm5.5,18.959h-5.5v-8.5h5.5a4.252,4.252,0,0,1,0,8.5m20.729-1.448a6.863,6.863,0,0,1-9.443,0,6.461,6.461,0,0,1-1.881-4.775,6.6,6.6,0,1,1,13.2,0,6.459,6.459,0,0,1-1.881,4.775m18.453,0a6.863,6.863,0,0,1-9.443,0,6.463,6.463,0,0,1-1.881-4.775,6.6,6.6,0,1,1,13.2,0,6.458,6.458,0,0,1-1.881,4.775m9.407-3.546c2.424.615,3.618,1.665,3.618,3.148a2.686,2.686,0,0,1-2.93,2.461,2.932,2.932,0,0,1-3.039-2.859h-2.747a9.873,9.873,0,0,0,.792-3.979,11.109,11.109,0,0,0-.082-1.288,7.647,7.647,0,0,0,4.389,2.517m-50.4,13.79-2.976,4.735v2.776h-.961v-2.776l-2.976-4.735h1.1l2.375,3.756,2.364-3.756Zm3.363-.131a3.636,3.636,0,0,0-2.723,1.121,3.79,3.79,0,0,0-1.087,2.766,3.831,3.831,0,0,0,1.087,2.775,3.88,3.88,0,0,0,5.435,0,3.836,3.836,0,0,0,1.1-2.775,3.8,3.8,0,0,0-1.1-2.766,3.611,3.611,0,0,0-2.712-1.121m2.005,5.978a2.834,2.834,0,0,1-4.021,0,3.125,3.125,0,0,1,0-4.181,2.83,2.83,0,0,1,4.021,0,3.094,3.094,0,0,1,0,4.181m7.553-5.846h.961v4.637a2.915,2.915,0,0,1-.854,2.144,2.816,2.816,0,0,1-2.11.861,2.849,2.849,0,0,1-2.111-.861,2.948,2.948,0,0,1-.844-2.144V1194.7h.96v4.616a2.074,2.074,0,0,0,.57,1.481,2.036,2.036,0,0,0,2.86,0,2.075,2.075,0,0,0,.57-1.481Zm6.266,3.734a2.364,2.364,0,0,0-.158-3.081,2.184,2.184,0,0,0-1.615-.653h-2.364v7.511h.971v-2.983h.792l1.847,2.983h1.171l-1.92-3.027a2.105,2.105,0,0,0,1.277-.751m-3.166-.076v-2.722h1.372a1.362,1.362,0,0,1,0,2.722Zm10.329-.131a1.866,1.866,0,0,0,.929-1.643,1.827,1.827,0,0,0-.538-1.35,1.8,1.8,0,0,0-1.33-.534h-2.459v7.511h2.765a2.05,2.05,0,0,0,.633-3.984m-2.459-2.623h1.288a1.1,1.1,0,0,1,1.107,1.143,1.126,1.126,0,0,1-.327.817,1.066,1.066,0,0,1-.78.326h-1.288Zm1.6,5.7h-1.6v-2.559h1.6a1.28,1.28,0,0,1,0,2.559m8.228-6.608h.961v4.637a2.916,2.916,0,0,1-.855,2.144,2.817,2.817,0,0,1-2.111.861,2.847,2.847,0,0,1-2.11-.861,2.947,2.947,0,0,1-.844-2.144V1194.7h.96v4.616a2.073,2.073,0,0,0,.57,1.481,2.037,2.037,0,0,0,2.86,0,2.075,2.075,0,0,0,.57-1.481Zm6.657,5.486a2,2,0,0,1-.676,1.546,2.451,2.451,0,0,1-1.688.61,2.4,2.4,0,0,1-1.689-.643,2.137,2.137,0,0,1-.675-1.612h.982a1.322,1.322,0,0,0,.4.969,1.408,1.408,0,0,0,1,.392,1.251,1.251,0,0,0,1.351-1.2c0-.676-.527-1.143-1.594-1.416-1.351-.337-2.026-1.076-2.026-2.2a1.9,1.9,0,0,1,.644-1.47,2.248,2.248,0,0,1,1.6-.6,2.222,2.222,0,0,1,1.6.622,2,2,0,0,1,.643,1.534h-.981a1.237,1.237,0,0,0-1.277-1.264,1.17,1.17,0,0,0-1.245,1.132c0,.642.5,1.1,1.488,1.361,1.425.36,2.132,1.111,2.132,2.232m.46-5.486H1315v.936h-.982v5.638H1315v.937h-2.924v-.937h.982v-5.638h-.982Zm9.124,0h.96v7.511h-.992l-4.116-5.845v5.845h-.971V1194.7h1l4.115,5.867Zm3.691,6.575h3.114v.937h-4.084V1194.7h4.031v.936h-3.061v2.329h2.712v.937h-2.712Zm8.376-1.089a2,2,0,0,1-.675,1.546,2.451,2.451,0,0,1-1.688.61,2.4,2.4,0,0,1-1.689-.643,2.135,2.135,0,0,1-.675-1.612h.981a1.32,1.32,0,0,0,.4.969,1.409,1.409,0,0,0,1,.392,1.251,1.251,0,0,0,1.351-1.2c0-.676-.528-1.143-1.594-1.416-1.35-.337-2.026-1.076-2.026-2.2a1.9,1.9,0,0,1,.644-1.47,2.249,2.249,0,0,1,1.6-.6,2.222,2.222,0,0,1,1.6.622,2,2,0,0,1,.643,1.534h-.981a1.237,1.237,0,0,0-1.277-1.264,1.17,1.17,0,0,0-1.245,1.132c0,.642.5,1.1,1.488,1.361,1.425.36,2.131,1.111,2.131,2.232m5.02,0a2,2,0,0,1-.676,1.546,2.451,2.451,0,0,1-1.688.61,2.4,2.4,0,0,1-1.689-.643,2.134,2.134,0,0,1-.676-1.612h.982a1.323,1.323,0,0,0,.4.969,1.409,1.409,0,0,0,1,.392,1.251,1.251,0,0,0,1.351-1.2c0-.676-.528-1.143-1.594-1.416-1.351-.337-2.026-1.076-2.026-2.2a1.9,1.9,0,0,1,.644-1.47,2.249,2.249,0,0,1,1.6-.6,2.222,2.222,0,0,1,1.6.622,2,2,0,0,1,.643,1.534h-.981a1.237,1.237,0,0,0-1.277-1.264,1.17,1.17,0,0,0-1.246,1.132c0,.642.5,1.1,1.489,1.361,1.424.36,2.132,1.111,2.132,2.232"
              transform="translate(-1264.323 -1163.938)"
            />
          </svg>
        </template>
      </div>
      <div class="header__border"></div>
      <p class="header__name">{{ $t("header.title") }}</p>
    </button>
    <HeaderBtns v-if="hasPageConfigLayout" />
  </header>
</template>

<script>
import HeaderBtns from "@/components/header/Btns.vue";

export default {
  props: {
    arrayPagesHasBg: {
      type: Array,
      required: true,
    },
  },
  components: {
    HeaderBtns,
  },
  computed: {
    isMobile() {
      return window.innerWidth < 992;
    },
    isPagesBg() {
      return this.arrayPagesHasBg.indexOf(this.$route.name) > -1;
    },
    hasPageConfigLayout() {
      if (this.$route.name === "config-layout" && this.isMobile) {
        return true;
      } else if (this.$route.name === "config-layout" && !this.isMobile) {
        return false;
      }

      return true;
    },
  },
  data() {
    return {};
  },
  methods: {
    redirectToHome() {
      if (["login", "home"].indexOf(this.$route.name) === -1) {
        this.$router.push({
          name: "home",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100px;
  background: var(--color-white);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 95px;
  z-index: 5;
  transition: 500ms;
  @media (max-width: 991px) {
    position: fixed;
    height: 86px;
    padding-right: 15px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  }
  &:before {
    content: "";
    display: block;
    position: absolute;
    left: -10px;
    top: -45px;
    width: 117px;
    height: 211px;
    background: url("~@/assets/img/bg-boost.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    z-index: -1;
    @media (max-width: 991px) {
      width: 113px;
      height: 105px;
      left: -54px;
      top: -19px;
      background: url("~@/assets/img/bg-boost-mobile.png");
    }
  }
  &__link {
    display: flex;
    align-items: center;
    gap: 15px;
    height: 100%;
    padding-left: 122px;
    text-decoration: none;
    background: 0;
    border: 0;
    @media (max-width: 991px) {
      padding-left: 65px;
      gap: 8px;
    }
  }
  &__logo {
    @media (max-width: 991px) {
      svg {
        max-width: 39px;
      }
    }
  }
  &__border {
    height: 50px;
    width: 1px;
    background: var(--color-green-3);
    @media (max-width: 991px) {
      height: 25px;
    }
  }
  &__name {
    font-size: 27px;
    font-family: "Font Light";
    color: var(--color-black);
    margin-bottom: 0;
    @media (max-width: 991px) {
      font-size: 14px;
    }
  }
  &--pages-bg {
    background: transparent;
    .header__border {
      background: var(--color-white);
    }
    .header__name {
      color: var(--color-white);
    }
  }
}
</style>
